import { TimelineParty } from '../slices/marketplace/timeline/models/enums/timeline-party.enum';
import { EngagementProcessStatus } from '../slices/marketplace/timeline/models/enums/engagement-process-status.enum';

export const canUseDaqiDataTools = (party?: TimelineParty | null): boolean =>
    party === TimelineParty.VetValue || party === TimelineParty.Broker;

export const canAdminEditDuringSuspension = (
    party: TimelineParty | undefined,
    status: EngagementProcessStatus | undefined
): boolean =>
    party === TimelineParty.VetValue && status === EngagementProcessStatus.Suspended;
